// extracted by mini-css-extract-plugin
module.exports = {"main":"styles__main___1jSsN","content":"styles__content___w4ljk","description":"styles__description___277Hr"};